// iOS Safari ignores viewport user-scalable=no since iOS 10. The
// workaround is to listen for `gesturestart` (Apple-specific) and
// also block multi-touch `touchmove` events that would otherwise
// trigger the system pinch-zoom — those were running in parallel
// with our internal calendar hour-height zoom and leaving the
// whole UI stuck at a zoomed-in transform. Double-tap zoom is
// also disabled via the maximum-scale meta + this touchend guard.
//
// Was previously an inline <script> in index.html but moving it
// here lets us drop 'unsafe-inline' from script-src in the CSP.
if (typeof document !== "undefined") {
  document.addEventListener("gesturestart", (e) => e.preventDefault(), { passive: false });
  document.addEventListener("gesturechange", (e) => e.preventDefault(), { passive: false });
  document.addEventListener("gestureend", (e) => e.preventDefault(), { passive: false });
  // (Removed double-tap touchend preventDefault — the viewport meta
  // `maximum-scale=1, user-scalable=no` already blocks double-tap zoom in
  // the Capacitor WKWebView, and the touchend guard was preventing iPad's
  // tap → focus → keyboard chain from firing on form inputs.)
}
